import React from 'react';
import { MonitorPlay } from 'lucide-react';
import { streamsAPI } from '../../lib/api';
import MediaContentManager, { youtubeId, youtubeThumb } from '../../components/admin/MediaContentManager';

const config = {
  title: 'Live Streams',
  description: 'YouTube live broadcasts and replays for the Live tab on the website and in the apps.',
  noun: 'live stream',
  icon: MonitorPlay,
  api: streamsAPI,
  liveField: 'is_live',
  thumbnail: (s) => youtubeThumb(s.youtube_url),
  subtitle: (s) => s.source,
  fields: [
    { name: 'title', label: 'Title', required: true, placeholder: 'Election night: live coverage' },
    {
      name: 'youtube_url', label: 'YouTube link', required: true, placeholder: 'https://youtube.com/live/…',
      help: 'The YouTube live or video link. Scheduled streams work too.',
      validate: (v) => (youtubeId(v) ? null : 'Paste a YouTube live or video link'),
    },
    { name: 'source', label: 'Source', default: 'Neural News' },
    { name: 'description', label: 'Description', type: 'textarea' },
    {
      name: 'is_live', label: 'Live now', type: 'switch', default: true,
      help: 'Shows the red Live badge and puts it first. Turn off when the broadcast ends to keep it as a replay.',
    },
  ],
};

export default function AdminLiveStreams() {
  return <MediaContentManager config={config} />;
}
